export enum ApiResponseStatus {
  SUCCESS = "SUCCESS",
  TOKEN_EXPIRED = "TOKEN_EXPIRED",
  TOKEN_INVALID = "TOKEN_INVALID",
  LICENSE_EXPIRED = "LICENSE_EXPIRED",
  LICENSE_INVALID = "LICENSE_INVALID",
  LICENSE_FAILED_VALIDATION = "LICENSE_FAILED_VALIDATION",
  ERROR = "ERROR",
}
